import Background from './components/background'
import Form from './components/join-form'
import Container from './components/container'
import { Helmet } from 'react-helmet'

const Join = () => (
    <Container>
        <Helmet>
            <title>Join | GIPHY</title>
        </Helmet>
        <Form />
        <Background />
    </Container>
)

export default Join
